import React, {Component} from 'react';
import {Button, Layout, Typography, Card} from "antd";
import MIDISounds from 'midi-sounds-react';
import {CaretRightOutlined, StopOutlined} from '@ant-design/icons';
import {drawExercise, playCorrect, playIncorrect, triadNames} from "./helper";
import {triads} from "./triads";
import {MidiPlayer} from "./MidiPlayer";

const {Content} = Layout;

let exercises = [];
triads.forEach(item => {
    exercises.push({
        ...item,
        inversion: 0
    });
    exercises.push({
        ...item,
        root: [item.root[0], item.root[1] + 1, item.root[2]],
        inversion: 1
    });
    exercises.push({
        ...item,
        root: [item.root[0], item.root[1] + 1, item.root[2]],
        third: [item.third[0], item.third[1] + 1, item.third[2]],
        inversion: 2
    });
});
let responses = [];
triadNames.forEach(item => {
    responses.push({...item, inversion: 0});
    responses.push({...item, inversion: 1});
    responses.push({...item, inversion: 2});
});

export default class HarmonicTriadInversionsTestContainer extends Component {

    state = {
        current: null,
        result: 0,
        exerciseNo: 0
    }

    start() {
        this.setState({current: drawExercise(exercises)});
    }

    stop() {
        this.setState({current: null, exerciseNo: 0, result: 0});
    }

    check(value) {
        let {result, exerciseNo} = this.state;
        if (this.state.current.type === value.name && this.state.current.inversion === value.inversion) {
            playCorrect();
            result++;
        } else {
            playIncorrect();
            alert('Prawidłowa odpowiedź to: ' + this.renderInversion({
                name: this.state.current.type,
                inversion: this.state.current.inversion
            }));
        }
        exerciseNo++;
        this.setState({result, exerciseNo, current: drawExercise(exercises)});
    }

    renderInversion(item) {
        switch (item.inversion) {
            case 1:
                return `${item.name} w I przewrocie`;
            case 2:
                return `${item.name} w II przewrocie`;
            default:
                return `${item.name} w postaci zasadniczej`;

        }
    }

    render() {
        return <Layout style={{background: '#fff', margin: '0 24px', padding: '0'}}>
            <Content style={{padding: '20px'}}>
                <div style={{textAlign: 'left'}}>
                    <Typography.Title level={3} style={{textTransform: 'uppercase', margin: '0'}}>
                        Przewroty trójdźwięków. Test audio
                    </Typography.Title>

                    <div style={{display: 'none'}}>
                        <MIDISounds
                            ref={(ref) => (this.midiSounds = ref)}
                            appElementName="root" instruments={[3]}
                        />
                    </div>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px',
                        justifyContent: 'center',
                        marginTop: '20px'
                    }}>

                        {
                            this.state.current ?
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <Card title={'Wynik'} style={{
                                        width: '250px',
                                        fontSize: '36px',
                                        textAlign: 'center',
                                        fontWeight: 'bold'
                                    }}
                                          bordered={true}
                                    >
                                        {this.state.result} / {this.state.exerciseNo}
                                    </Card>
                                    <Typography.Title level={4} style={{margin: '0'}}>
                                        Jaki to trójdźwięk?
                                    </Typography.Title>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '5px'
                                    }}>
                                        <Button type="primary"
                                                icon={<CaretRightOutlined/>}
                                                onClick={() => MidiPlayer.playTriad(this.midiSounds, this.state.current)}>
                                            Odsłuchaj
                                        </Button>
                                        <Button icon={<StopOutlined/>}
                                                onClick={() => this.stop()}>
                                            Zakończ
                                        </Button>
                                    </div>
                                    <p style={{marginTop: '10px'}}>Wskaż prawidłową odpowiedź:</p>
                                    <div style={{
                                        padding: '10px 10px',
                                        display: 'flex',
                                        gap: '10px',
                                        flexWrap: 'wrap',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        {
                                            responses.map(item => (
                                                <Card key={item.name + item.inversion}
                                                      style={{width: '150px', fontSize: '16px', textAlign: 'center'}}
                                                      hoverable={true}
                                                      bordered={true}
                                                      onClick={() => this.check(item)}
                                                >
                                                    {this.renderInversion(item)}
                                                </Card>
                                            ))
                                        }
                                    </div>
                                </div> :
                                <Button type="primary"
                                        onClick={() => this.start()}>
                                    Start
                                </Button>
                        }
                    </div>
                </div>
            </Content>
        </Layout>
    }
}
